import React, { useEffect, useState } from "react";
import "./ScheduleCall.scss";
import Modal from "components/shared/Modal";
import { Tooltip } from 'react-tooltip';
import moment from 'moment-timezone';
import { DropdownField } from "components/shared/DropdownField";
import { Image, Radio, Table } from 'semantic-ui-react';
import CONFIG from "config";
import authService from 'redux/auth';
import { getUserProfilePictures } from "api/getUserProfilePictures";
import { getUserId } from "utils/auth/auth";
import CrossIcon from "assets/images/cross-large.svg";
import CrossSmallIcon from 'assets/images/cross_icon.svg';
import InfoIcon from "assets/images/info-outline.svg";
import { setSaveCallSlotsAPIData } from "redux/actions/saveCallSlots/saveCallSlots.actions";
import { selectors as saveCallSelectors } from "redux/reducers/saveCallSlots/saveCallSlots_reducer";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { PeopleSelector } from "@kdshared/peopleselector";
import timezones from "timezones.json";
import Calendar from "react-calendar";
import TimeSlotSelector from 'components/shared/TimeSlotSelector/TimeSlotSelector';

export const ScheduleCall = ({ open, data, caseTeamMembers, requestId, closePopupHandler, isRescheduleWindowFlag, isFollowUpCallFlag }) => {
    const dispatch = useDispatch();
    const durationList = [
        { name: '15 mins', value: 15 },
        { name: '30 mins', value: 30 },
        { name: '60 mins', value: 60 },
        { name: '90 mins', value: 90 }
    ];

    const callScheduled = useSelector(saveCallSelectors.getSaveRequestResults);
    const callScheduledError = useSelector(saveCallSelectors.getErrorMessage)

    const [openModel, setOpenModel] = useState(open);
    const [accessToken, setAccessToken] = useState([]);
    const [slotOptionSelected, setSlotOptionSelected] = useState('expert');
    const [userSlotData, setUserSlotData] = useState([]);
    const [expertSlotData, setExpertSlotData] = useState([]);
    const [membersList, setMembersList] = useState([]);
    const [attendeeList, setAttendeeList] = useState([]);
    const [scheduleCallFlag, setScheduleCallFlag] = useState(false);
    const [peoplePrefilledList, setPeoplePrefilledList] = useState([]);
    const [userTimezone, setUserTimezone] = useState('Asia/Kolkata');
    const [disableSendBtn, setDisableSendBtnFlag] = useState(true);
    const [calendarSelection, setCalendarSelection] = useState(new Date());
    const [removedUserSelection, setRemovedUserSelection] = useState();
    const [selectedExpertTime, setSelectedExpertTime] = useState();
    const [disableSaveSlotBtnFlag, setDisableSaveSlotBtnFlag] = useState(true);
    const [selectedUserTime, setSelectedUserTime] = useState();
    const [savedSlotsArray, setSavedSlotsArray] = useState([]);
    const [timeSlotData, setTimeSlotData] = useState([]);
    const [userTimeSlotData, setUserTimeSlotData] = useState([]);
    const [userSelectionErrorFlag, setUserSelectionErrorFlag] = useState('');
    const [timeOptions, setTimeOptions] = useState({
        timeZone: userTimezone,
        hour: '2-digit',
        minute: '2-digit',
    });
    const [userSelection, setUserSelection] = useState({
        checked: true,
        date: '',
        duration: 60,
        durationDisplay: '60 mins',
        datetime: '',
        startTime: '',
        endTime: '',
        timezone: 'IST'
    });

    // Fetch the user timezone
    const getUserTimeZone = async () => {
        try {
            const hrid = await getUserId();
            const resp = await getUserProfilePictures([hrid]);

            if (resp?.length > 0 && resp[0]?.hostOfficeLocation?.timezone) {
                setUserTimezone(resp[0].hostOfficeLocation.timezone);
                setTimeOptions({ ...timeOptions, timeZone: resp[0].hostOfficeLocation.timezone });
                const timezoneDetails = timezones.find((tz) => tz.utc.includes(resp[0].hostOfficeLocation.timezone));
                if (timezoneDetails) {
                    setUserSelection((selection) => {
                        const updatedList = { ...selection };
                        updatedList['timezone'] = timezoneDetails.abbr;
                        return updatedList;
                    });
                }
            }
        } catch (error) {
            setUserTimezone('Error fetching timezone');
        }
    };

    useEffect(() => {
        getUserTimeZone();
    }, []);

    useEffect(() => {
        if (userSelection.duration) {
            if (slotOptionSelected == 'user') {
                generateUserSlots();
            } else {
                setExpertSlotData((expertData) => {
                    let updatedData = [...expertData];
                    updatedData.forEach((slot) => {
                        slot.availableSlots = [];
                        slot.startTimeArray.forEach((t, index) => {
                            const availableTimeSlots = generateTimeSlots(t, slot.endTimeArray[index], userSelection.duration);
                            slot.availableSlots = [...slot.availableSlots, ...availableTimeSlots];
                        })
                    });
                    return updatedData;
                });
            }
        }
    }, [userSelection.duration]);

    useEffect(() => {
        renderTimeSlotsBasedOnDate()
    }, [expertSlotData]);
    useEffect(() => {
        setAccessToken(authService.getAccessToken());
        setUserSelection((selection) => {
            const updatedList = { ...selection };
            updatedList['timezone'] = moment().tz(moment.tz.guess()).format('z');
            return updatedList;
        });

        return () => {
            setScheduleCallFlag(false);
        };
    }, []);

    useEffect(() => {
        renderTimeSlotsBasedOnDate();
    }, [calendarSelection]);

    useEffect(() => {
        if (scheduleCallFlag && callScheduled) {
            if (callScheduled.status?.toLowerCase().includes('success')) {
                toast.success('The slots have been successfully shared with the networks.');
                setOpenModel(false);
                closePopupHandler(true);
            } else if (callScheduled.error?.message) {
                toast.error(callScheduled.error?.message);
            }
        }
    }, [callScheduled]);

    useEffect(() => {
        if (callScheduledError) {
            toast.error(callScheduledError);
        }
    }, [callScheduledError]);

    useEffect(() => {
        if (caseTeamMembers?.length > 0) {
            handleRequestorName(caseTeamMembers);
        }
    }, [caseTeamMembers]);

    useEffect(() => {
        if (isRescheduleWindowFlag) {
            if (data.duration) {
                setUserSelection((selection) => {
                    const updatedList = { ...selection };
                    updatedList['duration'] = data.duration;
                    updatedList['durationDisplay'] = data.duration + ' mins';

                    return updatedList;
                });
            }
            if (data.selectedSlots) {
                const date = new Date(data.selectedSlots.startDateTime).toLocaleDateString();
                const localStartDateTime = new Date(data.selectedSlots?.startDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: true });
                const localEndDateTime = new Date(data.selectedSlots?.endDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: true });
                const localStartDateTime1 = new Date(data.selectedSlots?.startDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: false });
                const localEndDateTime1 = new Date(data.selectedSlots?.endDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: false });

                if (!data.selectedSlots.isExpertSlot) {
                    setUserSlotData(() => {
                        let updatedData = [];
                        const selectionData = getTimeInterval(localStartDateTime1, localEndDateTime1);
                        const duplicateSlotRecord = updatedData.findIndex((slot) => slot.date == date);
                        if (duplicateSlotRecord > -1) {
                            const newTimeSlot = selectionData.timeInterval;
                            if (updatedData[duplicateSlotRecord].time.findIndex((t) => t.slot == newTimeSlot) < 0) {
                                updatedData[duplicateSlotRecord].time.push({
                                    checked: false,
                                    disable: true,
                                    slot: newTimeSlot,
                                    startTime: localStartDateTime,
                                    endTime: localEndDateTime
                                });
                                updatedData[duplicateSlotRecord].checked = true;
                            } else {
                                toast.info('Time already added.');
                            }
                        } else {
                            const newSelectionDetails = {
                                date: date,
                                day: getDay(new Date(data.selectedSlots.startDateTime)),
                                checked: false,
                                disable: true,
                                time: [{
                                    checked: false,
                                    disable: true,
                                    slot: selectionData.timeInterval,
                                    startTime: localStartDateTime,
                                    endTime: localEndDateTime
                                }],
                                timezone: userTimezone
                            };
                            updatedData.push(newSelectionDetails);
                        }

                        return updatedData;
                    });
                }
            }
        }
        if (data.availableSlots?.length > 0) {
            data.availableSlots.forEach((avlSlot) => {
                const startDate = new Date(avlSlot.startDateTime);
                const endDate = new Date(avlSlot.endDateTime);
                const selectedDateValue = startDate.toLocaleDateString();

                setExpertSlotData((expertData) => {
                    let updatedData = [...expertData];
                    if (avlSlot.isExpertSlot) { //need to modify after BE changes
                        const availableTimeSlots = generateTimeSlots(startDate, endDate, userSelection.duration);
                        const duplicateSlotRecord = updatedData.findIndex((slot) => slot.date == selectedDateValue);
                        // const selectedSlotRecord = data.selectedSlots ? new Date(data.selectedSlots.startDateTime).toLocaleDateString() == selectedDateValue && data.selectedSlots.isExpertSlot : false;
                        if (duplicateSlotRecord > -1) {
                            updatedData[duplicateSlotRecord].availableSlots = [...updatedData[duplicateSlotRecord].availableSlots, ...availableTimeSlots];
                            updatedData[duplicateSlotRecord].startTimeArray.push(startDate);
                            updatedData[duplicateSlotRecord].endTimeArray.push(endDate);
                        } else {
                            const newSelectionDetails = {
                                date: selectedDateValue,
                                startTimeArray: [startDate],
                                endTimeArray: [endDate],
                                availableSlots: availableTimeSlots,
                                timezone: userSelection.timezone
                            };

                            // if (selectedSlotRecord) {
                            //     const selectedSlotDiff = msToTime(new Date(data.selectedSlots.endDateTime).getTime() - new Date(data.selectedSlots.startDateTime).getTime(), 'diff'),
                            //         selectedStartDateTime = new Date(data.selectedSlots?.startDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: true }),
                            //         selectedEndDateTime = new Date(data.selectedSlots?.endDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: true });
                            //     newSelectionDetails.selectedTimeString = 'Scheduled Slot : ' + selectedSlotDiff + ' (' + selectedStartDateTime + ' ' + ' - ' + selectedEndDateTime + ')';
                            //     newSelectionDetails.selectedStartTime = new Date(data.selectedSlots.startDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: false });
                            //     newSelectionDetails.selectedEndTime = new Date(data.selectedSlots.endDateTime)?.toLocaleTimeString('en-US', { ...timeOptions, hour12: false });
                            // }
                            updatedData.push(newSelectionDetails);
                        }
                    }
                    return updatedData;
                });
            });
        }
    }, [data]);

    useEffect(() => {
        if (savedSlotsArray?.length > 0 && (attendeeList?.length > 0 || membersList?.length > 0)) {
            setDisableSendBtnFlag(false);
        } else {
            setDisableSendBtnFlag(true);
        }
    }, [savedSlotsArray]);

    const renderTimeSlotsBasedOnDate = () => {
        if (calendarSelection) {
            if (slotOptionSelected == 'user') {
                generateUserSlots();
            } else {
                const recIndex = expertSlotData.findIndex((es) => new Date(es.date).toDateString() == new Date(calendarSelection).toDateString());
                if (recIndex > -1) {
                    setTimeSlotData(() => {
                        return expertSlotData[recIndex].availableSlots;
                    });
                } else {
                    setTimeSlotData([]);
                }
            }
        }
    }

    const handleRequestorName = async (caseTeam) => {
        let resp = [];
        let arr = [];
        for (let i = 0; i < caseTeam?.length; i++) {
            arr?.push(caseTeam[i]?.hrId);
        }
        setPeoplePrefilledList(arr);
        if (arr?.length > 0) {
            resp = await getUserProfilePictures(arr);
            setMembersList((member) => {
                let updatedList = [...member];
                if (resp?.length > 0) {
                    resp.forEach((record) => {
                        updatedList.push({ name: record?.lastName?.concat(', ').concat(record?.firstName), email: record.email, hrid: record.id });
                    });
                }
                return updatedList;
            });
        }
    }

    const formatHrsMinsString = (dataString) => {
        const requestString = dataString.length == 1 ? '0' + dataString : dataString;
        return requestString;
    }

    const getTimeInterval = (start, end) => {
        const starttimeArray = start.split(':'), endtimeArray = end.split(':');

        const hh = Number(starttimeArray[0].trim()) > 12 ? Number(starttimeArray[0].trim()) - 12 : Number(starttimeArray[0].trim());
        const mm = starttimeArray[1];

        const endMM = endtimeArray[1];
        const endHH = Number(endtimeArray[0].trim()) > 12 ? Number(endtimeArray[0].trim()) - 12 : Number(endtimeArray[0].trim());

        let endTimePeriod = (Number(endtimeArray[0].trim()) > 12 || Number(endtimeArray[0].trim()) == 12) ? 'PM' : 'AM',
            startTimePeriod = (Number(starttimeArray[0].trim()) > 12 || Number(starttimeArray[0].trim()) == 12) ? 'PM' : 'AM';

        const startHrs = formatHrsMinsString(hh.toString());
        const startMins = formatHrsMinsString(mm.toString());
        const endHrs = formatHrsMinsString(endHH.toString());
        const endMins = formatHrsMinsString(endMM.toString());

        if (endHrs == '00') {
            endTimePeriod = 'AM';
        }
        if (startHrs == '00') {
            startTimePeriod = 'AM';
        }

        const startTimeString = startHrs == '00' ? '12:' + startMins : startHrs + ':' + startMins;
        const endTimeString = endHrs == '00' ? '12:' + endMins : endHrs + ':' + endMins;

        const timeInterval = endTimePeriod == startTimePeriod ? startTimeString + ' - ' + endTimeString + ' ' + endTimePeriod : startTimeString + ' ' + startTimePeriod + ' - ' + endTimeString + ' ' + endTimePeriod;

        return { timeInterval };
    }

    const getDay = (date) => {
        const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let selectedDay = weekday[date.getDay()];
        return selectedDay;
    }

    const extractSelectedSlotsData = () => {
        let selectedData = [];
        savedSlotsArray.forEach((slot) => {
            if (!slot.error) {
                let formatedData = {
                    "endDateTime": new Date(slot.endTime).toISOString(),
                    "startDateTime": new Date(slot.time).toISOString(),
                    "isExpertSlot": slotOptionSelected == 'expert'
                };
                selectedData.push(formatedData);
            }
        });
        return selectedData;
    }

    const sendSlotsHandler = () => {
        const attendeeData = mergedMembers();
        const slotsSelectedData = extractSelectedSlotsData();
        if (attendeeData?.length > 0 && slotsSelectedData?.length > 0) {
            const requestData = {
                "requestId": requestId,
                "projectId": data.projectId,
                "isReschedule": isRescheduleWindowFlag ? true : false,
                "expertProfile": {
                    "id": data.id,
                    "profileId": data.profileId,
                    "networkProvider": data.networkProvider
                },
                "followUpCall": isFollowUpCallFlag ? true : false,
                "duration": userSelection.duration,
                "reason": null,
                "selectedSlots": slotsSelectedData,
                "attendees": attendeeData
            };
            if (isRescheduleWindowFlag || (!isRescheduleWindowFlag && !isFollowUpCallFlag && data.callId)) {
                requestData['id'] = data.callId;
            }
            setScheduleCallFlag(true);
            dispatch(setSaveCallSlotsAPIData({ data: requestData }));
        } else {
            toast.error('Either attendee list or call slots were not selected.')
        }
    }

    const mergedMembers = () => {
        let updatedList = [];
        if (attendeeList?.length > 0) {
            updatedList = [...attendeeList];
        }
        else if (membersList?.length > 0) {
            membersList.forEach((item) => {
                updatedList.push({
                    "attendeeEmail": item.email,
                    "attendeeHrId": item.hrid
                });
            });
        }
        return updatedList;
    }

    const updateAttendeeSelection = (e) => {
        if (e.selectionArray && e.selectionArray.length > 0) {
            let memberSelected = e.selectionArray;
            setAttendeeList(() => {
                const updatedMemberList = [];
                memberSelected.forEach((select) => {
                    const newData = {
                        "attendeeEmail": select.email ? select.email : select.workEmail,
                        "attendeeHrId": select.id
                    };
                    updatedMemberList.push(newData);
                });
                return updatedMemberList;
            });
        }
    }

    const durationSelactionHandler = (selected) => {
        setExpertSlotData((slotData) => {
            const slotUpdatedList = [...slotData];
            slotUpdatedList.forEach((slot) => {
                if (slot.checked) {
                    slot.showTimeSelection = !slot.checked;
                    slot.checked = !slot.checked;
                }
                if (!slot.disable) {
                    slot.userStartTime = '';
                    slot.userTimeFieldType = 'text';
                }
                slot.error = false;
            });
            return slotUpdatedList;
        });
        if (isRescheduleWindowFlag) {
            setUserSlotData(() => {
                let updatedData = [];
                userSlotData.forEach((slot) => {
                    if (slot.time?.length > 0) {
                        const keepSlot = { ...slot, time: [] };
                        slot.time.forEach((t) => {
                            if (t.disable) {
                                keepSlot.time.push(t);
                            }
                        });
                        if (keepSlot.time?.length > 0) {
                            updatedData.push(keepSlot);
                        }
                    }
                });
                return updatedData;
            });
        } else {
            setUserSlotData([]);
        }
        setUserSelection((selection) => {
            const updatedList = { ...selection };
            updatedList['duration'] = selected.slice(0, 2);
            updatedList['durationDisplay'] = selected;
            updatedList['startTime'] = '';
            updatedList['endTime'] = '';
            updatedList['timeError'] = '';

            return updatedList;
        });
    }

    const generateTimeSlots = (start, end, interval) => {
        const timeSlots = [];
        let currentTime = new Date(start);

        while (currentTime < end) {
            timeSlots.push({
                displayValue: currentTime.toLocaleTimeString([], { ...timeOptions }),
                value: new Date(currentTime)
            });
            currentTime = new Date(currentTime.getTime() + interval * 60000);
        }

        return timeSlots;
    };

    const generateUserSlots = () => {
        const start = calendarSelection;
        const endOfDay = new Date(start).setHours(23, 59, 0, 0);
        const timeInterval = generateTimeSlots(calendarSelection, endOfDay, userSelection.duration);
        setUserTimeSlotData(timeInterval);
    }

    const highlightDate = ({ date, view }) => {
        if (view === 'month' && slotOptionSelected == 'expert') {
            if (expertSlotData.find(d => new Date(d.date).toDateString() === new Date(date).toDateString())) {
                return 'highlight';
            }
        }
        return null;
    };

    const userSlotSelectionHandler = (data) => {
        setSelectedUserTime(data);
        let slotError = false;
        data.forEach((time) => {
            if (time.error) {
                slotError = time.error;
            }
        });
        setUserSelectionErrorFlag(slotError);
        setDisableSaveSlotBtnFlag(data.length == 0 || slotError ? true : false);
    }

    const expertSlotSelectionHandler = (slot) => {
        if (selectedExpertTime == slot) {
            setSelectedExpertTime(null);
            setDisableSaveSlotBtnFlag(true);
        } else {
            setSelectedExpertTime(slot);
            setDisableSaveSlotBtnFlag(false);
        }
    }

    const onSaveSlotBtnClick = () => {
        if (!calendarSelection) {
            console.error('Date Selection is missing');
            return;
        }

        let savedValueData = {};
        const calculateEndTime = (startTime, duration) => new Date(startTime.getTime() + duration * 60000);

        if (slotOptionSelected === 'expert' && selectedExpertTime?.value instanceof Date && !isNaN(selectedExpertTime.value)) {
            const endTime = calculateEndTime(selectedExpertTime.value, userSelection.duration);
            const timeString = `${selectedExpertTime.displayValue} to ${endTime.toLocaleTimeString([], { ...timeOptions })}`;
            savedValueData = {
                date: calendarSelection,
                time: selectedExpertTime.value,
                endTime,
                display: `${calendarSelection.toDateString()} , ${timeString}`
            };
            const duplicateSlotIndex = savedSlotsArray.findIndex((s) => s.display == savedValueData.display);
            if (duplicateSlotIndex == -1) {
                setSavedSlotsArray((prevSlots) => [...prevSlots, savedValueData]);
            }
        } else if (selectedUserTime) {
            selectedUserTime.forEach((selection) => {
                const { start, end } = selection;
                const duplicateSelectionIndex = savedSlotsArray.findIndex((s) => s.time == start && s.endTime == end);
                if (duplicateSelectionIndex == -1) {
                    const timeString = `${start.toLocaleTimeString([], { ...timeOptions })} to ${end.toLocaleTimeString([], { ...timeOptions })}`;
                    savedValueData = {
                        date: calendarSelection,
                        time: start,
                        endTime: end,
                        display: `${calendarSelection.toDateString()} , ${timeString}`
                    };
                    setSavedSlotsArray((prevSlots) => [...prevSlots, savedValueData]);
                }
            })
        }
    };

    const slotTypeOptionHandler = (type) => {
        setSlotOptionSelected(type);
        setCalendarSelection(new Date());
        setSelectedExpertTime(null);
        setSavedSlotsArray([]);
        setUserSlotData([]);
        setTimeSlotData([]);
        setDisableSaveSlotBtnFlag(true);
        if (type == 'user') {
            generateUserSlots()
        }
    }

    const removeSavedSlotData = (slot) => {
        setSavedSlotsArray(() => {
            return savedSlotsArray.filter((savedSlot) => savedSlot.display !== slot.display);
        });
        setRemovedUserSelection({ 'start': slot.time, 'end': slot.endTime });
    }

    return (
        <Modal isOpen={openModel} className="schedulecall__modal">
            <div className="schedulecall__wrapper model-wrapper">
                <div className="model-header">
                    <img className="close-icon" src={CrossIcon} alt="close" onClick={() => { setOpenModel(false); closePopupHandler(false); }} />
                    <div className="schedulecall__heading">
                        <span>Schedule Call with {data?.expertName}</span>
                    </div>
                </div>
                <div className="model-body" id="modelBody">
                    <div className="schedulecall__common-block">
                        <div className="time-timezone">
                            <div className="step-label">
                                <span className="step-count">Step 1 :</span>
                                Select Call duration
                                <span className="mandatory">*</span>
                                <div className="timezone-value"><span className="step-count">Time Zone:</span> {userSelection.timezone}</div>
                            </div>
                            <div id="duration-field" className='expert-time-field'>
                                <DropdownField data={durationList} fieldIndex='0' name='duration' fieldId='duration' placeholderTxt='Select duration'
                                    selectedValue={userSelection.durationDisplay}
                                    onSelectHandler={(selected) => durationSelactionHandler(selected)}
                                    onFocusOutHandler={() => { return true; }} />

                            </div>
                        </div>
                        <div className="meeting-invites">
                            <div className="step-label">
                                <span className="step-count">Step 2 :</span> Choose case team member(s) to be added  to the Invite
                            </div>
                            <PeopleSelector
                                label=''
                                name="originalRequestor"
                                apiKey={CONFIG.PEOPLE_API_X_API_KEY}
                                accessToken={accessToken}
                                environment='preproduction-internal'
                                fieldHeight="48px"
                                preFillData={[peoplePrefilledList]}
                                onChange={(e) => updateAttendeeSelection(e)}
                            />
                        </div>
                    </div>
                    <div className="schedulecall__details">
                        <div className="slots-selection">
                            <div className="step-label">
                                <span className="step-count">Step 3 : </span>
                                Choose a slot for your meeting by following one of the options
                            </div>
                            <div className="slot-selection-container">
                                <div className="slot__options">
                                    <Radio
                                        label='Choose a slot from expert&lsquo;s availability'
                                        name='slot_option'
                                        value='expert'
                                        id="expSurveys"
                                        checked={slotOptionSelected === 'expert'}
                                        onChange={() => slotTypeOptionHandler('expert')}
                                    />
                                    <Radio
                                        label='Share your availability with networks'
                                        name='slot_option'
                                        value='user'
                                        id="shareSurveys"
                                        checked={slotOptionSelected === 'user'}
                                        onChange={() => slotTypeOptionHandler('user')}
                                    />
                                </div>
                                <div className="slot_selecting">
                                    <Table>
                                        <Table.Body className='slots-grid-view'>
                                            <Table.Row>
                                                <Table.Cell className='bold-text'>Select Date</Table.Cell>
                                                <Table.Cell className='bold-text time-header-cell'>Select Time Slot
                                                    <Tooltip anchorSelect=".tooltip-regional" place="bottom-end" effect='solid' multiline={true} className="small-tooltip">
                                                        You can select multiple slots. Please click <b>Save Slot</b> after every slot selection.
                                                    </Tooltip>
                                                    <a className="tooltip-regional"><Image className="info-img" src={InfoIcon} alt="Info icon" /></a>
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>
                                                    <Calendar
                                                        onChange={(date) => {
                                                            setCalendarSelection(date);
                                                        }}
                                                        minDate={new Date()}
                                                        value={calendarSelection}
                                                        tileClassName={highlightDate} />
                                                </Table.Cell>
                                                <Table.Cell className={`${slotOptionSelected == 'expert' && timeSlotData.length == 0 && "no-slot-data"}`}>
                                                    {slotOptionSelected == 'expert' ?
                                                        <div className="time-slots expert-time-slots" >
                                                            {timeSlotData.length == 0 ?
                                                                <div className="no--slots">
                                                                    No slots shared by network
                                                                </div>
                                                                : timeSlotData.map((time, index) => (
                                                                    <div key={'pin' + index} className={`time-pin ${selectedExpertTime?.displayValue == time.displayValue && 'selected-time-pin'}`} onClick={() => { expertSlotSelectionHandler(time) }}>{time.displayValue}</div>))
                                                            }
                                                        </div> :
                                                        <>
                                                            <div className="user-time-slots time-slots">
                                                                <TimeSlotSelector duration={userSelection.duration} selectedDate={calendarSelection} removedSelection={removedUserSelection} slotSelectionHandler={(data) => userSlotSelectionHandler(data)} />
                                                            </div>
                                                        </>
                                                    }
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell>
                                                    <div className="slot-colors">
                                                        <div className="selected-color-block"></div>
                                                        <span>Selected Slot</span>
                                                        <div className="available-color-block"></div>
                                                        <span>Available Slots</span>
                                                    </div>
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <div className="save-slot-btn-block">
                                                        {userSelectionErrorFlag && <span className="error-txt">{userSelectionErrorFlag}</span>}
                                                        <button className="save-slot-btn" onClick={() => onSaveSlotBtnClick()} disabled={!calendarSelection || disableSaveSlotBtnFlag}>Save Slot</button>
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                    {savedSlotsArray?.length > 0 &&
                                        <div className="selected-slots">
                                            <span>Selection: </span>
                                            {savedSlotsArray.map((savedSlot, index) => (
                                                <div key={'ss' + index} className="saved-slot-block">
                                                    {savedSlot.display}
                                                    <div className="remove-icon"><Image src={CrossSmallIcon} alt="search icon" className={`close--button`} onClick={() => removeSavedSlotData(savedSlot)} /></div>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="schedulecall__action-container model-footer">
                    <button className="default-button" onClick={() => { sendSlotsHandler() }} disabled={disableSendBtn}>Send Slots to Network</button>
                </div>
            </div>
        </Modal>
    );
};